import React from "react";
import { motion } from "framer-motion";
import { FaAddressBook, FaHistory, FaUserCheck } from "react-icons/fa";
import { crmContactFeatures } from "../../data/crmPageContent";
import { CrmContactProfileMockup } from "./CrmMockups";
import { CrmReveal } from "./CrmMotion";

const icons = [FaAddressBook, FaHistory, FaUserCheck];

export const CrmContactSection = () => (
    <section className="crm-contact">
        <div className="crm-container crm-contact__split">
            <CrmReveal className="crm-contact__visual">
                <CrmContactProfileMockup />
            </CrmReveal>

            <CrmReveal delay={0.1} className="crm-contact__copy">
                <h2 className="crm-h2">Complete Contact Management</h2>
                <p className="crm-lead">
                    Every customer interaction in one profile — so your team always has the full picture.
                </p>

                <ul className="crm-contact__list">
                    {crmContactFeatures.map((item, i) => {
                        const Icon = icons[i];
                        return (
                            <motion.li
                                key={item.label}
                                className="crm-contact__list-item"
                                whileHover={{ x: 6 }}
                            >
                                <div className="crm-contact__list-icon">
                                    <Icon size={18} />
                                </div>
                                <div>
                                    <strong>{item.label}</strong>
                                    <p>{item.description}</p>
                                </div>
                            </motion.li>
                        );
                    })}
                </ul>
            </CrmReveal>
        </div>
    </section>
);
